import {
  TIPO_PESSOA_SELECIONAR,
  TIPO_NECESSIDADE_SELECIONAR,
  TIPO_PRODUTO_SELECIONAR,
  SET_TIPO_PRODUTO,
  LOADING_TIPO_PRODUTO,
  ERROR_TIPO_PRODUTO,
  VALUE_TIPO_PRODUTO,
  SET_TIPO_CONTRATO,
  SET_LOGO_PARCEIRO,
} from './types'

const initialState = {
  tipoPessoaValue: null,
  tipoNecessidade: null,
  tipoProdutoValue: null,
  tipoContrato: '',
  listTipoProduto: [],
  loadingTipoProduto: false,
  errorListTipoProduto: null,
  logoParceiro: null
}


export default function tipoCadastroReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TIPO_CONTRATO:
      return { ...state, tipoContrato: action.payload }
    case TIPO_PESSOA_SELECIONAR:
      return { ...state, tipoPessoaValue: action.payload }
    case TIPO_NECESSIDADE_SELECIONAR:
      return { ...state, tipoNecessidade: action.payload }
    case TIPO_PRODUTO_SELECIONAR:
      return { ...state, tipoProdutoValue: action.payload }
    case SET_TIPO_PRODUTO:
      return { ...state, listTipoProduto: action.payload }
    case LOADING_TIPO_PRODUTO:
      return { ...state, loadingTipoProduto: action.payload }
    case ERROR_TIPO_PRODUTO:
      return { ...state, errorListTipoProduto: action.payload }
    case VALUE_TIPO_PRODUTO:
      return { ...state, tipoProdutoValue: action.payload }
    case SET_LOGO_PARCEIRO:
      return { ...state, logoParceiro: action.payload }
    default:
      return state
  }
}


